<app-print-receipt *ngIf="this.mode === 'single'"
  [receiptDetails]="receiptDetails"
  [companyLogo]="companyLogo"
  [shipmentType]="shipmentType"
  [user]="user"
  [selectedCustomer]="selectedCustomer"
  [hideStatusCodes]="hideStatusCodes"
  [hideParcelInfo]="hideParcelInfo"
  [hideRating]="hideRating"
  [hideSignature]="hideSignature"
  [hideDestinationAddress]="hideDestinationAddress"
  [hideOriginAddress]="hideOriginAddress"
  [hideLogo]="hideLogo"
  [hideRequiredDriverInputs]="hideRequiredDriverInputs"
  [dateTimeFormat]="dateTimeFormat">
</app-print-receipt>

<app-print-multiple-receipts *ngIf="this.mode === 'multiple'"
  [bulkReceipts]="bulkReceipts"
  [companyLogo]="companyLogo"
  [user]="user"
  [selectedCustomer]="selectedCustomer"
  [hideStatusCodes]="hideStatusCodes"
  [hideParcelInfo]="hideParcelInfo"
  [hideRating]="hideRating"
  [hideSignature]="hideSignature"
  [hideDestinationAddress]="hideDestinationAddress"
  [hideOriginAddress]="hideOriginAddress"
  [hideLogo]="hideLogo"
  [hideRequiredDriverInputs]="hideRequiredDriverInputs"
  [dateTimeFormat]="dateTimeFormat">
</app-print-multiple-receipts>
